// The claims of a JWT OpenChat signed, read without checking its signature: the services it's for
// check that
export function jwtClaims(token) {
    const parts = token.split(".");
    if (parts.length < 2)
        return undefined;
    try {
        const claims = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")), (c) => c.charCodeAt(0))));
        return typeof claims === "object" && claims !== null
            ? claims
            : undefined;
    }
    catch {
        return undefined;
    }
}
export function jwtExpiryMs(token) {
    const exp = jwtClaims(token)?.exp;
    return typeof exp === "number" ? exp * 1000 : undefined;
}
